import Icon from '../components/Icon.vue';
Icon.register({
  signal: {
    width: 640,
    height: 512,
    paths: [{
      d: 'M216 288c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-192c0-8.8 7.2-16 16-16h48zM88 384c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h48zM344 192c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-288c0-8.8 7.2-16 16-16h48zM472 96c8.8 0 16 7.2 16 16v384c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-384c0-8.8 7.2-16 16-16h48zM600 0c8.8 0 16 7.2 16 16v480c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-480c0-8.8 7.2-16 16-16h48z'
    }]
  }
});